import { generatePath } from "react-router-dom";
import { tViews } from "../../../../../../../utils/table";
import { routeURLs } from "../../../../../../../utils/enums";
import css from "../../../common/anomalyMagneticStyle.less";

const siteSelection = (rowData, navigate, setSelectedSite) => {
    localStorage.setItem("local_details", JSON.stringify(
      { "local_site": rowData.site_name ,
        "local_location": rowData.city,
      }));
    setSelectedSite(rowData.site_id);
    navigate(generatePath(routeURLs.adSingleSite, { siteName: rowData.site_name }));
}
export const getColumns = (navigate, setSelectedSite, openTableSettings) => {
    return [
        { id:'site_name_col',
          prop:'site_name',
          get name() { return tViews('adSites.anomaly_summary.label.site')},
          sortable: true,
          size: 180,
          cellTemplate: (createElement, prop) => {
            return createElement("hbr-link", 
            {
              "onHbr-focus": (e) => {
                e.preventDefault()
                siteSelection(prop.model, navigate, setSelectedSite)
              },
               "aria-label": tViews('a11yLabels.viewDetailswithSite', {siteName: prop.model.site_name}),
              tabIndex: 0
            }, prop.model.site_name);
          },
          cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}` }),
        },
        { id:'location_col',
          prop:'city',
          get name() { return tViews('adSites.anomaly_summary.label.location')},
          sortable: true,
          size: 180
        },
        { id:'anomaly_rate_col',
          prop:'anomaly_rate',
          get name() { return tViews('adSites.anomaly_summary.label.anomalyRate')},
          sortable: true,
          size: 180
        },
        { id:'display_tunnel_usage_col',
          prop:'display_tunnel_usage',
          get name() { return tViews('adSites.anomaly_summary.label.tunnelUsage')},
          sortable: true,
          size: 180
        },
        { id:'impacted_remote_site_cnt_col',
          prop:'impacted_remote_site_percent',
          get name() { return tViews('adSites.anomaly_summary.label.impactedRemoteSite')},
          sortable: true,
          size: 250,
          columnTemplate: (h) => {
            return h("hbr-icon-button", {
              id: "remote-site-popover",
              slot: "suffix",
              class: css["icon-button-small-padding"],
              name: "info",
               "aria-label":`${tViews('a11yLabels.infoAboutremoteSites')}`,
              tabIndex: 0,
              role: "button",
              innerHTML: `
              <hbr-portal>
                <hbr-tooltip anchor="#remote-site-popover" content="${tViews('predictiveNetworks.remoteSitesImpacted')}">
                </hbr-tooltip>
              </hbr-portal>
            `,
            });
          },
        },
        { id:'total_remote_site_cnt_col',
          prop:'total_remote_site_cnt',
          get name() { return tViews('adSites.anomaly_summary.label.totalRemoteSite')},
          sortable: true,
          size: 180
        },
        { id:'impacted_tunnel_cnt_col',
          prop:'impacted_tunnel_percent',
          get name() { return tViews('adSites.anomaly_summary.label.impactedTunnel')},
          sortable: true,
          size: 200,
          columnTemplate: (h) => {
            return h("hbr-icon-button", {
              id: "tunnels-popover",
              slot: "suffix",
              class: css["icon-button-small-padding"],
              name: "info",
              innerHTML: `
              <hbr-portal>
                <hbr-tooltip anchor="#tunnels-popover" content="${tViews('predictiveNetworks.tunnelImpacted')}">
                </hbr-tooltip>
              </hbr-portal>
            `,
            });
          },
        },
        { id:'total_tunnel_cnt_col',
          prop:'total_tunnel_cnt',
          get name() { return tViews('adSites.anomaly_summary.label.totalTunnel')},
          sortable: true,
          size: 180
        },
        { id:'app_cnt_col',
          prop:'app_cnt',
          get name() { return tViews('adSites.anomaly_summary.label.applications')},
          sortable: true,
          size: 180
        },
        {
          id: "actions_col",
          prop: "actions",
          name: "Actions",
          hiddenText: "Actions",
          disableToggle: true,
          sortable: false,
          headerSlot: false,
          pin: "colPinEnd",
          size: 70,
          columnTemplate: (createElement) => {
            return createElement("hbr-icon-button", {
              name: "gear-six-outlined",
              class: "hbr-css__table-cell-align-center gear-icon",
              aria: { label: tViews('tableSettings') || "Table settings" },
              "data-testid": "setting-ad-sites-table",
              onClick: (evt) => {
                evt.stopPropagation();
                openTableSettings();
              }
            });
          }
        }
    ];
}
